import { configApi } from '../../../shared/utils/http-client.js'
import { showSnackbar } from '../../../shared/state/snackbar.js'

/**
 * Request an exchange token redirect URL for a target micro-frontend.
 * @param {string} targetAppKey optional target app key (e.g. 'risk')
 * @returns {Promise<string>} the absolute redirect URL containing the exchange token
 */
export async function createExchangeTokenRedirect (targetAppKey) {
	try {
		const body = targetAppKey ? { targetAppKey: targetAppKey } : {}
		const { data } = await configApi.post('/api/admin-portal-microservice/create-exchange-token', body)
		// Actual backend response: { exchangeToken: string, expiresAt: string, targetUrl: string }
		if (!data || !data.targetUrl) {
			showSnackbar({ text: 'Failed to obtain exchange token redirect URL', color: 'red' })
			return null
		}
		return data.targetUrl
	} catch (e) {
		// http-client may have displayed an error already
		return null
	}
}

/**
 * Perform the full flow: request redirect URL, then navigate if successful.
 * @param {string} targetAppKey
 */
export async function navigateToMicroFrontend (targetAppKey) {
	const redirectUrl = await createExchangeTokenRedirect(targetAppKey)
	if (redirectUrl) {
		// Defensive: open in same tab to preserve cookie context
		window.location.href = redirectUrl
	}
}
